import React, { Fragment } from 'react'
import { Col, Card, Row, Input, Table, CardBody, CardHeader, FormGroup, Label, Button } from 'reactstrap';
import { useReportCredit } from '../../../hooks/Pbi/useReportCredit';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from "primereact/inputtext";
import { TabView, TabPanel } from 'primereact/tabview';
import { Chart } from 'primereact/chart';
import { Tag } from 'primereact/tag';
import Select from 'react-select';
import { Line } from "react-chartjs-2";






export const IndexReportCreditPending = () => {

    const {
        setFilters, filters, cancellPatient, globalCancellFilter, chartDataCancell,
        chartOptionsCancell, countPatient,
        setGlobalCancellFilter, handleReport,
        loadingCancell, exportToExcelCancell, branches, handleSelectValuesCash, mSelectBranch, chartOptions, chartData,
        handleViewCard, handleCloseCard, viewCard, totalPending, maxDay,
        totalPendiente, totalPagado, ordenesPendientes






    } = useReportCredit();

    const formatAmount = (amount) => {
        return amount.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }


    const customBody = (rowData) => {
        return (
            <div
                style={{
                    border: "2px solid orange",
                    borderRadius: "12px",
                    cursor: "pointer",
                    textAlign: "center",
                    backgroundColor: "#f8f8f8",
                    fontWeight: "bold",
                    fontSize: "12px"
                }}
            >
                {rowData.nim}
            </div>
        );
    };

    const customStatus = (rowData) => {
        const baseStyle = { width: "82px", fontSize: "10px", textAlign: "center" };

        return (
            <Tag style={baseStyle} severity={rowData.fully_paid ? "success" : "danger"} value={rowData.fully_paid ? "Pagado" : "Pendiente"} />
        );
    };
    const iconCreditStyle = {
        width: 48,
        height: 48,
        borderRadius: 12,
        backgroundColor: "#fdecea",
        color: "#dc3545",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 22,
        fontWeight: "bold"
    };





    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <div style={{ paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "111%", transformOrigin: "top left", textAlign: "center", height: "20%" }}>
                <Card style={{
                    marginBottom: '15px',
                    background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                    border: 'none',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}>
                    <CardBody style={{ padding: '18px 25px' }}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <div style={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginRight: '15px'
                                }}>
                                    <img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/laboratory-External/icon-credit.svg")} style={{ width: "60px", height: "60px" }} />
                                </div>
                                <div>
                                    <h4 className="mb-1" style={{ color: '#fff', fontWeight: 700, fontSize: '20px', textAlign: "justify" }}>
                                        Reporte de Créditos
                                    </h4>
                                    <small style={{ color: 'rgba(255,255,255,0.85)', fontSize: '13px' }}>
                                        <i className="fa fa-info-circle mr-1"></i>
                                        Análisis detallado de los saldos pendientes en pacientes particulares
                                    </small>
                                </div>
                            </div>

                        </div>
                    </CardBody>
                </Card>
                {
                    // *REPORT
                }
                <Card className='shadow-sm border height-equal pricingtable mb-0 pb-0' style={{ paddingTop: "1px", paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "113%", transformOrigin: "top left", textAlign: "center", height: "95%" }}>
                    <Col sm="12" className='pt-3'>

                        <Row>
                            <Col sm="2" className='p-l-0 p-r-0' style={{ textAlign: "left" }}>
                                <Card style={{
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                    border: 'none',
                                    height: '100%',
                                    borderRadius: '12px'
                                }}>
                                    <CardHeader style={{
                                        background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                                        color: 'white',
                                        padding: '15px',
                                        borderRadius: '12px 12px 0 0'
                                    }}>
                                        <h6 className="mb-0" style={{ fontWeight: 700, fontSize: '15px' }}>
                                            <i className="fa fa-filter mr-2"></i>Filtros de Búsqueda
                                        </h6>
                                    </CardHeader>
                                    <CardBody style={{ padding: '20px' }}>
                                        <FormGroup>
                                            <Label className='f-w-600' style={{ fontSize: '12px', marginBottom: '10px', color: '#333' }}>
                                                <i className="fa fa-calendar-alt mr-2" style={{ color: '#007bff' }}></i>Fecha de inicio
                                            </Label>
                                            <Input
                                                type='date'
                                                value={filters.dateStart}
                                                onChange={(e) => {
                                                    setFilters({ ...filters, dateStart: e.target.value })
                                                }}
                                                className='form-control'
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '1px solid #ddd',
                                                    padding: '10px',
                                                    fontSize: '13px'
                                                }}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label className='f-w-600' style={{ fontSize: '12px', marginBottom: '10px', color: '#333' }}>
                                                <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Fecha de cierre
                                            </Label>
                                            <Input
                                                type='date'
                                                value={filters.dateEnd}
                                                onChange={(e) => {
                                                    setFilters({ ...filters, dateEnd: e.target.value })
                                                }}
                                                className='form-control'
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '1px solid #ddd',
                                                    padding: '10px',
                                                    fontSize: '13px'
                                                }}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label className='f-w-600' style={{ fontSize: '12px', marginBottom: '10px', color: '#333' }}>
                                                <i className="fa fa-building mr-2" ></i>Sucursal
                                            </Label>
                                            <Select
                                                name="mSelectBranch"
                                                isClearable={true}
                                                placeholder="Selecciona una sucursal"
                                                options={branches}
                                                onChange={(e) => handleSelectValuesCash(e, 'mSelectBranch')}
                                                value={mSelectBranch}
                                                styles={{
                                                    menuPortal: base => ({
                                                        ...base,
                                                        zIndex: 999999
                                                    }),
                                                    control: base => ({
                                                        ...base,
                                                        borderRadius: "8px",
                                                        border: "1px solid #ddd",
                                                        minHeight: "42px",
                                                        boxShadow: "none"
                                                    }),
                                                    placeholder: base => ({
                                                        ...base,
                                                        fontSize: "13px"
                                                    })
                                                }}
                                            />
                                        </FormGroup>
                                        <br />
                                        <b>Acciones</b>
                                        <br /><br />
                                        <Button
                                            onClick={() => handleReport()}

                                            color="primary"
                                            block
                                            outline
                                            className="mb-3"
                                            style={{
                                                borderRadius: '10px',
                                                padding: '6px',
                                                fontSize: '14px',
                                                fontWeight: 600,
                                                borderWidth: '2px'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                        >
                                            Buscar
                                        </Button>

                                        {
                                            viewCard && <Button
                                                onClick={() => handleCloseCard()}

                                                color="dark"
                                                block
                                                outline
                                                className="mb-3"
                                                style={{
                                                    borderRadius: '10px',
                                                    padding: '6px',
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                    borderWidth: '2px'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                            >
                                                <i className="fa fa-file-archive-o"></i>&ensp;
                                                Reporte
                                            </Button>
                                        }
                                        {
                                            !viewCard && <Button
                                                onClick={() => handleViewCard()}

                                                color="dark"
                                                block
                                                outline
                                                className="mb-3"
                                                style={{
                                                    borderRadius: '10px',
                                                    padding: '6px',
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                    borderWidth: '2px'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                            >
                                                <i className="pi pi-chart-bar"></i>&ensp;
                                                Graficos
                                            </Button>

                                        }

                                        <Button
                                            color="success"
                                            onClick={() => exportToExcelCancell(cancellPatient)}
                                            block
                                            style={{
                                                borderRadius: '10px',
                                                padding: '6px',
                                                fontSize: '13px',
                                                fontWeight: 600,
                                                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                                transition: 'all 0.3s'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                            title="Descargar reporte"
                                        >
                                            <i className="pi pi-file-excel"></i>&ensp;
                                            Descargar
                                        </Button>

                                    </CardBody>


                                </Card>
                            </Col>

                            <Col sm="10">
                                <div style={{
                                    marginTop: '1px',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                    borderRadius: '12px',
                                    overflow: 'hidden',
                                    backgroundColor: '#fff'
                                }}>
                                    <Col sm="12">
                                        {
                                            viewCard && <div>
                                                <Row className="mb-4 g-3">

                                                    {/* ===== CRÉDITO PENDIENTE ===== */}
                                                    <Col md="4">
                                                        <Card className="border-0 shadow-sm h-100">
                                                            <CardBody className="d-flex align-items-center gap-3 pt-3 pb-3 pl-4 pr-4">
                                                                <div
                                                                    style={iconCreditStyle}>
                                                                    💳
                                                                </div>

                                                                <div>
                                                                    <small className="text-muted d-block">
                                                                        Crédito pendiente
                                                                    </small>
                                                                    <h3 className="mb-0 text-danger fw-bold">
                                                                        ${totalPendiente.toLocaleString()}
                                                                    </h3>
                                                                    <small className="text-muted">
                                                                        Adeudo activo del periodo
                                                                    </small>
                                                                </div>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>

                                                    {/* ===== CRÉDITO RECUPERADO ===== */}
                                                    <Col md="4">
                                                        <Card className="border-0 shadow-sm h-100">
                                                            <CardBody className="d-flex align-items-center gap-3 ">
                                                                <div
                                                                    style={{
                                                                        width: 48,
                                                                        height: 48,
                                                                        borderRadius: 12,
                                                                        backgroundColor: "#eafaf1",
                                                                        color: "#198754",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        fontSize: 22,
                                                                        fontWeight: "bold"
                                                                    }}
                                                                >
                                                                    ✅
                                                                </div>

                                                                <div>
                                                                    <small className="text-muted d-block">
                                                                        Crédito recuperado
                                                                    </small>
                                                                    <h4 className="mb-0 text-success fw-semibold">
                                                                        ${totalPagado.toLocaleString()}
                                                                    </h4>
                                                                    <small className="text-muted">
                                                                        Pagos aplicados
                                                                    </small>
                                                                </div>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>

                                                    {/* ===== ÓRDENES PENDIENTES ===== */}
                                                    <Col md="4">
                                                        <Card className="border-0 shadow-sm h-100">
                                                            <CardBody className="d-flex align-items-center gap-3">
                                                                <div
                                                                    style={{
                                                                        width: 48,
                                                                        height: 48,
                                                                        borderRadius: 12,
                                                                        backgroundColor: "#fff4e5",
                                                                        color: "#fd7e14",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        fontSize: 22,
                                                                        fontWeight: "bold"
                                                                    }}
                                                                >
                                                                    ⏳
                                                                </div>

                                                                <div>
                                                                    <small className="text-muted d-block">
                                                                        Órdenes pendientes
                                                                    </small>
                                                                    <h4 className="mb-0 fw-bold">
                                                                        {ordenesPendientes}
                                                                    </h4>
                                                                    <small className="text-muted">
                                                                        Por liquidar
                                                                    </small>
                                                                </div>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>

                                                </Row>


                                                <div style={{ height: "280px" }}>
                                                    <Line data={chartData} options={chartOptions} />
                                                </div>




                                            </div>
                                        }
                                        {
                                            !viewCard && <DataTable
                                                className="data-table"
                                                globalFilter={globalCancellFilter}
                                                value={cancellPatient}
                                                paginator
                                                stripedRows
                                                rows={10}
                                                rowsPerPageOptions={[10, 30, 50, 100, 200, 300]}
                                                emptyMessage={
                                                    <div className="text-center">
                                                        <img
                                                            src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                            style={{ width: "25%" }}
                                                            alt="Sin resultados"
                                                        />
                                                        <br />
                                                        <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>No se a generada ningún descuento.</p>
                                                    </div>
                                                }
                                                loading={loadingCancell}
                                                loadingIcon="pi pi-spin pi-spinner"

                                            >
                                                <Column
                                                    header="#"
                                                    body={(rowData, { rowIndex }) => rowIndex + 1}
                                                    style={{
                                                        textAlign: "center",
                                                        fontSize: "12px",
                                                        width: "9%",
                                                    }}
                                                    headerStyle={{
                                                        backgroundColor: "#1d5b83",
                                                        color: "#fff",
                                                        fontWeight: "bold",
                                                        fontSize: "12px",
                                                        padding: "12px",
                                                    }}
                                                />
                                                <Column
                                                    field="fech"
                                                    header="Fecha de ingreso"
                                                    sortable
                                                    headerStyle={{
                                                        backgroundColor: "#1d5b83",
                                                        color: "#fff",
                                                        fontWeight: "bold",
                                                        fontSize: "12px",
                                                        padding: "12px",
                                                    }}
                                                    style={{
                                                        fontSize: "12px",
                                                        textAlign: "center",
                                                        width: "10%",
                                                    }}
                                                />


                                                <Column
                                                    field="nim"
                                                    header="Nim"
                                                    sortable
                                                    headerStyle={{
                                                        backgroundColor: "#1d5b83",
                                                        color: "#fff",
                                                        fontWeight: "bold",
                                                        fontSize: "12px",
                                                        padding: "12px",
                                                    }}
                                                    style={{
                                                        fontSize: "12px",
                                                        textAlign: "center",
                                                        width: "10%",
                                                    }}
                                                    body={customBody}
                                                />
                                                <Column
                                                    field="userResponsable"
                                                    header="usuario de alta"
                                                    sortable
                                                    headerStyle={{
                                                        backgroundColor: "#1d5b83",
                                                        color: "#fff",
                                                        fontWeight: "bold",
                                                        fontSize: "12px",
                                                        padding: "12px",
                                                    }}
                                                    style={{
                                                        fontSize: "12px",
                                                        textAlign: "center",
                                                        width: "10%",
                                                    }}
                                                />

                                                <Column
                                                    field="branch"
                                                    header="Sucursal"
                                                    sortable
                                                    headerStyle={{
                                                        backgroundColor: "#1d5b83",
                                                        color: "#fff",
                                                        fontWeight: "bold",
                                                        fontSize: "12px",
                                                        padding: "5px",
                                                    }}
                                                    style={{
                                                        fontSize: "12px",
                                                        textAlign: "center",
                                                        width: "10%",
                                                    }}
                                                />

                                                <Column
                                                    field="amount_deposit"
                                                    header="Monto"
                                                    sortable
                                                    headerStyle={{
                                                        backgroundColor: "#1d5b83",
                                                        color: "#fff",
                                                        fontWeight: "bold",
                                                        fontSize: "12px",
                                                        padding: "5px",
                                                    }}
                                                    style={{
                                                        fontSize: "12px",
                                                        textAlign: "center",
                                                        width: "10%",
                                                    }}
                                                    body={(rowData) => `$${formatAmount(rowData.amount_deposit)}`}
                                                />

                                                <Column
                                                    field="fully_paid"
                                                    header="Estatus"
                                                    sortable
                                                    headerStyle={{
                                                        backgroundColor: "#1d5b83",
                                                        color: "#fff",
                                                        fontWeight: "bold",
                                                        fontSize: "12px",
                                                        padding: "12px",
                                                    }}
                                                    style={{
                                                        fontSize: "12px",
                                                        textAlign: "center",
                                                        width: "10%",
                                                    }}
                                                    body={customStatus}
                                                />
                                                <Column
                                                    field="name_recupered"
                                                    header="Usuario de recuperación"
                                                    sortable
                                                    headerStyle={{
                                                        backgroundColor: "#1d5b83",
                                                        color: "#fff",
                                                        fontWeight: "bold",
                                                        fontSize: "12px",
                                                        padding: "5px",
                                                    }}
                                                    style={{
                                                        fontSize: "12px",
                                                        textAlign: "center",
                                                        width: "10%",
                                                    }}
                                                />
                                                <Column
                                                    field="fech_recupered"
                                                    header="fecha de recuperación"
                                                    sortable
                                                    headerStyle={{
                                                        backgroundColor: "#1d5b83",
                                                        color: "#fff",
                                                        fontWeight: "bold",
                                                        fontSize: "12px",
                                                        padding: "5px",
                                                    }}
                                                    style={{
                                                        fontSize: "12px",
                                                        textAlign: "center",
                                                        width: "10%",
                                                    }}
                                                />
                                            </DataTable>

                                        }
                                    </Col>



                                </div>
                            </Col>

                        </Row>
                    </Col>
                </Card>
            </div >

        </div >

    )
}

